import { Toaster } from 'sonner'
import { useIsPhone } from '../hooks/useMediaQuery'

// Single universal toast surface for every app (my/frame/ping/auth/admin).
// Brand-card background (not richColors' per-type pastel backgrounds) so every
// toast sits on the same chrome as the rest of the UI. The per-type coloured
// icons are restored via the `[data-sonner-toast][data-type=...] [data-icon]`
// CSS rule each app's index.css defines against the shared status tokens.
//
// Bottom-right on a desktop, TOP-CENTRE on a phone. The bottom of a phone
// screen is already spoken for: the till stacks a Review bar there, the add-on
// panel puts "Add to ticket" there, the ticket pane ends in "Charge", and under
// all of them sits the home indicator. A toast landing on that pile covers the
// button the message is usually telling someone to press, and on a narrow
// screen "bottom-right" is the full width anyway — so it is not a corner, it is
// a lid over the primary action.
export function AppToaster() {
  const isPhone = useIsPhone()
  return (
    <Toaster
      position={isPhone ? 'top-center' : 'bottom-right'}
      closeButton
      toastOptions={{
        classNames: {
          toast: 'brand-chrome-light !bg-card !text-card-foreground !border-border !shadow-lg !rounded-xl',
          title: '!text-card-foreground !font-semibold',
          description: '!text-muted-foreground',
          closeButton: '!bg-card !text-muted-foreground !border-border hover:!text-foreground',
        },
      }}
    />
  )
}
